import React, {Component} from "react";
import Dashboard from "./Dashboard";
import MainPages from "../MainPages";
import {Route, Router, Switch} from "react-router-dom";
import ManageHome from "../ManageHome";
import Hdash from "./Hdash";
import Ehraz from "./Ehraz";
import DashboardBody from "./DashboardBody";




export default function MangeDashboard ({children,state = 0}){

    const route = [
        { path: '/',
            component: Hdash
        },
        { path: '/ehraz',
          component: Ehraz,
         }



         
]



React.useEffect(() => {


const script = document.createElement("script")

script.src =
  "./script-chat.js"

script.async = true
    script.type = "text/javascript";




script.crossOrigin = "anonymous"

document.body.appendChild(script)

return () => {
  // clean up the script when the component in unmounted
  document.body.removeChild(script)
}
}, [])




    return(

        <>

            <Dashboard state={state}/>
            <DashboardBody>{children}</DashboardBody>





        </>
    )
}